import { calculateAgeFromDOB, formatDate, fullAddress, fullName } from '../../utils/getPostRole'

export const matrimonialExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{ label: 'Name', render: p => fullName(p) },
	{ label: 'Mobile', render: p => p?.mobile || '' },
	{ label: 'Education', render: p => p?.education || '' },
	{ label: 'Profession', render: p => p?.profession || '' },
	{ label: 'DOB', render: p => p?.dob || '' },
	{
		label: 'Age',
		render: p => p?.age || (p?.dob ? calculateAgeFromDOB(p?.dob) : ''),
	},
	{ label: 'Height', render: p => p?.height || '' },
	{ label: 'Goutra', render: p => p?.goutra || '' },
	{
		label: 'Income (LPA)',
		render: p => p?.incomeBand || '',
	},
	{ label: 'Native Address', render: p => fullAddress(p) },
	{ label: 'Created Date', render: p => formatDate(p?.createdAt) },
]
